import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpErrorComponent } from './fcp-error.component';
import { FcpIconModule } from '../fcp-icon';

@NgModule({
    declarations: [FcpErrorComponent],
    imports: [CommonModule, FcpIconModule],
    exports: [FcpErrorComponent]
})
export class FcpErrorModule {}
